module.exports = __webpack_public_path__ + "img/hsbc-img.e2d8dece.png";